import React, { useState, useEffect, useMemo } from "react"
import {useTranslation} from "react-i18next";
import i18next from "i18next";
function FaqSection(props) {
    const {t, i18n} = useTranslation('common');
    let rem_faq = props?.MetaData?.rem_faq
    if (rem_faq != undefined) {
        try {
            rem_faq = JSON.parse(rem_faq)
        } catch (e) {
        }
    }
    const [faq_Data, setFaq_Data] = useState(rem_faq);
    useEffect(() => {
        if( props?.lan == 'en' ) {
            i18next.changeLanguage("en");
        }else{
            i18next.changeLanguage("el");
        }
    }, []); 
    return (<section class="gallery_section faqs_section rem_nav_section" id="faqs_section">
        <div class="container_size ">
            <h3 class="FAQ_heading">{t('FAQ’s')}</h3>
            {(faq_Data != '') ? faq_Data.map(function (all_Data, i) {
                return (
                    <div class="question_answer_box">
                        <div>
                            <button class="accordion">{all_Data?.question}</button>
                            <div class="panel">
                                <p>{all_Data?.answer}</p>
                            </div>
                        </div>
                    </div>
                );
            }) : ''}

        </div>
    </section>);
}

export default FaqSection;